var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user_header_button",on:{"click":_vm.toggleAccountSwitcher}},[_c('AccountImage',{attrs:{"size":28,"initial":_vm.initial}}),_c('font-awesome-icon',{staticClass:"user_header_button__icon",class:{
            'user_header_button__icon--flipped': _vm.trayOpenPercentage > 0,
        },attrs:{"icon":['fas', 'chevron-down']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }